module.exports = __webpack_public_path__ + "static/M1-d2538885c6edd4206404e765be825585.jpg";